import { COMMA, ENTER } from "@angular/cdk/keycodes";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { MatChipInputEvent } from "@angular/material/chips";
import { ActivatedRoute, Router } from "@angular/router";
import { AlertController, LoadingController, Platform } from "@ionic/angular";
import { STORAGE } from "src/app/constant/storages";
import {
  _deleteStorage,
  _getStorage,
  _setStorage,
} from "src/app/utils/local-storage";
import { ApiserviceService } from "../../../../httpservice/apiservice.service";
import { AppService } from "../../../../services/app.service";
import { errMsg } from "../../../../text_control/error-msg";
import { ADDRESS } from "../../../../text_control/text_address";
import { BTN } from "../../../../text_control/text_button";

export interface Phone {
  numbers: string;
}

@Component({
  selector: "app-tax-invoice-edit",
  templateUrl: "./tax-invoice-edit.component.html",
  styleUrls: ["./tax-invoice-edit.component.scss"],
})
export class TaxInvoiceEditComponent implements OnInit {
  public text_addr: any = {};
  public text_btn: any = {};
  dataedit1 = [];
  dataedit: any = {};
  dataAddress: any;
  myparam: any;
  phone = "";
  room_no = "";
  floor = "";
  building_name = "";
  showbranch2 = true;
  radio_group = "";
  buyer_branch_no = "";
  buyer_main_branch_no = "";
  // radio_group = "";
  disable_buyer = false;
  buyer_type = "";
  buyer_agree_tmp = "";
  template_lang = "";
  postcode = "";
  showbtn1 = false;
  showbtn2 = true;
  showbtn3 = true;
  showedit = true;
  showselect = true;
  showback = true;
  showContinue = false;

  sub_district: any = {};
  district: any = {};
  province: any = {};

  subDistrict: any = [];
  postcodes: any = [];

  District: any;
  sub_District: any;
  dataprovince: any;
  datadistrict: any;
  datasubdistrict: any;

  zipcode: any;

  showfont1 = false;
  showfont2 = false;
  showfont3 = false;
  showbranch = true;

  dataprovinces: any;
  datadistricts: any;
  datasubdistricts: any;
  dataphone: any = [];

  dataCountry: any = [];
  country: any = "";
  dataCountrysearch: any = [];

  showTH = false;
  showEN = true;

  addrENCountry = "";
  addrENPostCode = "";
  addrENProvince = "";
  addrEN = "";
  addrENOther = "";

  showOther = false;
  redioaddress = "1";

  emailEN = "";
  telEN = "";
  itemEN: any;

  showaddrTH = true;
  showaddrEN = true;

  dataProvince: any;
  groupAddress: any;
  groupProvince: any;
  isFindAddress = false;
  searchAddress = "";
  searchProvince = "";
  addressManual = false;

  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";

  isAddress = false;
  addressline1 = "";
  isThai = false;

  constructor(
    public alertController: AlertController,
    public route: Router,
    public router: ActivatedRoute,
    public apiservice: ApiserviceService,
    public appService: AppService,
    public http: HttpClient,
    public loadingController: LoadingController,
    public platform: Platform
  ) {
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.text_addr = ADDRESS;
    this.text_btn = BTN;
    this.ionViewDidEnter();
  }

  ngOnInit() {
    this.ionViewDidEnter();
    this.addressManual = false;
    this.groupAddress = this.appService.address_thai;
    window.onclick = function (event) {
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      var showprovince = document.getElementById("showSelectProvince");
      var notshowprovince = document.getElementById("notshowselectProvince");
      if (x !== null) {
        x.style.display = "none";
        y.style.display = "none";
      }
      if (showprovince !== null) {
        showprovince.style.display = "none";
        notshowprovince.style.display = "none";
      }
    };
    let groupData = [];
    this.groupAddress.forEach((v, i) => {
      const index = groupData.findIndex((f) => f.province === v.province);
      if (index === -1) {
        groupData = [...groupData, v];

        this.dataProvince = groupData;
      } else {
        return;
      }
    });
  }

  checkAddress(e) {
    console.log("checkAddress event =======:: ", e);
    this.isAddress = e.detail.checked;
    if (!e.detail.checked) {
      let dataInit = _getStorage(STORAGE.DATA_EDIT);
      this.sub_district = dataInit.address_detail[0].sub_district;
      this.district = dataInit.address_detail[0].district;
      this.province = dataInit.address_detail[0].province;
      this.dataAddress.postcode = dataInit.address_detail[0].postcode;
    }
  }

  filterAddress(e) {
    let val = e.target.value;
    if (val.trim() !== "") {
      this.groupAddress = this.appService.address_thai.filter((item) => {
        return (
          String(item.zipcode).indexOf(val) > -1 ||
          item.province.indexOf(val) > -1 ||
          item.amphoe.indexOf(val) > -1 ||
          item.district.indexOf(val) > -1
        );
      });
      var x = document.getElementById("showselect");
      var y = document.getElementById("notshowselect");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }

  selectAddress(item) {
    this.sub_district = item.district;
    this.district = item.amphoe;
    this.province = item.province;
    this.dataAddress.postcode = item.zipcode;
    this.isFindAddress = false;
    this.searchAddress = "";
  }
  filterProvince(e) {
    const val = e.target.value.trim();
    if (val !== "") {
      this.groupProvince = this.dataProvince.filter((item) =>
        item.province.includes(val)
      );
      const x = document.getElementById("showSelectProvince");
      const y = document.getElementById("notshowselectProvince");
      if (this.groupAddress.length > 0) {
        y.style.display = "none";
        if (x.style.display === "none") {
          x.style.display = "block";
        }
      } else {
        x.style.display = "none";
        if (y.style.display === "none") {
          y.style.display = "block";
        }
      }
    }
  }
  selectProvince(item) {
    this.province = item.province;
    this.searchProvince = "";
  }
  clearAddress(name) {
    if (name === "Postcode") {
      this.dataAddress.postcode = "";
    }
    if (name === "Province") {
      this.province = "";
    }
    if (name === "District") {
      this.district = "";
    }
    if (name === "SubDistrict") {
      this.sub_district = "";
    }
  }

  ionViewDidEnter() {
    this.appService.setActive(2);
    this.reloadcountry();
    this.dataedit = _getStorage(STORAGE.DATA_EDIT);
    console.log("data edit ====:: ", this.dataedit);
    this.buyer_type = String(this.dataedit.buyer_type);
    this.buyer_agree_tmp = this.dataedit.buyer_agree_tmp;
    this.template_lang = this.dataedit.template_lang;
    this.postcode = this.dataedit.postcode;
    let data1 = [];
    data1 = this.dataedit.address_detail;
    this.itemEN = this.dataedit.address_detail[0];
    this.showback = true;
    this.showbtn1 = false;
    this.showbtn2 = true;
    this.showbtn3 = true;
    this.showedit = true;
    this.showselect = true;
    this.showContinue = false;
    this.isAddress = this.itemEN.is_addresstxt;
    this.addressline1 = this.itemEN.addressline1;

    if (this.dataedit.buyer_main_branch_no) {
      this.radio_group = this.dataedit.buyer_main_branch_no;
    } else {
      this.radio_group = this.dataedit.buyer_branch_no;
    }
    if (this.dataedit.buyer_type === "0") {
      this.showfont1 = true;
      this.showfont2 = false;
      this.showfont3 = false;
      this.showbranch = false;
    } else if (this.dataedit.buyer_type === "1") {
      this.showbranch = true;
      this.showfont1 = false;
      this.showfont2 = true;
      this.showfont3 = false;
    } else if (this.dataedit.buyer_type === "2") {
      this.showbranch = false;
      this.showfont1 = false;
      this.showfont2 = false;
      this.showfont3 = true;
    }
    if (this.itemEN.type_addr === "1") {
      this.redioaddress = "1";
      this.showTH = true;
      this.showEN = true;
    } else if (this.itemEN.type_addr === "2") {
      this.redioaddress = "2";
      this.showTH = true;
      this.showEN = true;
    }

    // ============ START ADDRESS EN ============//

    let country: any;
    country = this.dataCountry.filter(
      (i) => i.name === this.itemEN.inter_country
    );

    console.log("country=====>", country);
    if (country.length > 0) {
      this.addrENCountry = country[0].name + ":" + country[0].code;
    }
    this.addrENPostCode = this.itemEN.inter_postcode;
    this.addrENProvince = this.itemEN.inter_province;
    this.addrEN = this.itemEN.inter_address_line1;
    this.emailEN = this.itemEN.email;
    this.telEN = this.itemEN.inter_tel;
    // ============ START ADDRESS EN ============//
    for (let i = 0; i < data1.length; i++) {
      this.dataAddress = data1[i];
      this.sub_district = this.dataAddress.sub_district;
      this.district = this.dataAddress.district;
      this.province = this.dataAddress.province;
      this.postcode = this.dataAddress.postcode;
      this.dataphone = this.dataAddress.phone.split(",");
      if (this.dataphone[0] === "") {
        this.dataphone = "";
      }
    }
    this.phoneNumbers = [];
    for (let i of this.dataphone) {
      this.phoneNumbers.push({
        numbers: i,
      });
    }
  }

  searchaddrEN(search) {
    let val: string = search;
    if (val.trim() !== "") {
      this.dataCountry = this.dataCountrysearch.filter((item) => {
        return item.name.toLowerCase().indexOf(val.toLowerCase()) > -1;
      });
    }

    if (val === "") {
      this.reloadcountry();
    }
  }
  reloadcountry() {
    // this.addrENCountry = this.appService.Country[0]
    this.dataCountry = this.appService.Country;
    this.dataCountrysearch = this.appService.Country;
  }
  checkbranch1() {
    this.showbranch2 = true;
    this.buyer_branch_no = "";
  }
  checkbranch2() {
    this.showbranch2 = false;
  }

  editdata() {
    this.showedit = false;
    this.showbtn1 = true;
    this.showbtn2 = false;
    this.showbtn3 = false;
    this.showaddrEN = false;
    this.showaddrTH = false;
    if (this.itemEN.type_addr === "1") {
      this.redioaddress = "1";
      this.showTH = false;
      this.showEN = true;
    } else if (this.itemEN.type_addr === "2") {
      this.redioaddress = "2";
      this.showTH = true;
      this.showEN = false;
    }
  }
  async ErrorMsg(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      message: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {
            //
          },
        },
      ],
    });
    await alert.present();
  }

  checkPostcodeEN(e) {
    this.addrENPostCode = e.target.value.match(/[0-9]*/)[0];
  }
  checkpostcode(e) {
    this.dataAddress.postcode = e.target.value.match(/[0-9]*/)[0];
  }

  datasave: any;
  async manualAlert(message: string) {
    let alert = await this.alertController.create({
      cssClass: "my-custom-class",
      subHeader: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {},
        },
      ],
    });
    await alert.present();
  }

  checkphone(e) {
    this.phone = e.target.value.match(/[0-9]*/)[0];
  }
  checkphoneEN(e) {
    this.telEN = e.target.value.match(/[0-9]*/)[0];
  }

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;

  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  phoneNumbers: Phone[];

  add(e: MatChipInputEvent, n): void {
    const input = e.input;
    const value = e.value;
    if ((value || "").trim()) {
      this.phoneNumbers.push({ numbers: value.trim() });
    }
    if (input) {
      input.value = "";
    }
  }

  remove(phone: Phone): void {
    const index = this.phoneNumbers.indexOf(phone);
    if (index >= 0) {
      this.phoneNumbers.splice(index, 1);
    }
  }

  gototaxinvoicesearchbuy() {
    this.appService.setActive(3);
    const v = JSON.stringify(this.datasave[0]);
    const btoaData = btoa(unescape(encodeURIComponent(v)));
    this.route.navigate(["/tax-invoice-search-buy"], {
      queryParams: { dataABB: btoaData },
    });
  }
  next() {
    _setStorage(STORAGE.DATA_ABB, this.dataedit);
    _setStorage(STORAGE.DATA_SELECTTAXINVOICE, [this.dataedit]);
    this.route.navigate(["/tax-invoice-search-buy"]);
  }
  checkemail(e) {
    this.dataAddress.email = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }
  checkemailEN(e) {
    this.emailEN = e.target.value.match(/[0-9a-z._@A-Z- ]*/)[0];
  }

  checkaddressTH() {
    this.template_lang = "TH";
    this.showTH = false;
    this.showEN = true;
  }
  checkaddressEN() {
    this.template_lang = "EN";
    this.showTH = true;
    this.showEN = false;
  }

  backselecttaxinvoice() {
    this.route.navigate(["/tax-invoice-select"]);
  }

  checkaddrENOther() {
    this.showOther = this.addrENCountry !== "Other" ? false : true;
  }

  async confirmBuyer() {
    let addr_type = this.redioaddress;

    let phones = [];
    for (let i of this.phoneNumbers) {
      phones.push(i.numbers);
    }

    let addr = {
      sub_district:
        this.dataedit.showcard === true
          ? this.checkUndefined(this.sub_district)
          : this.checkUndefined(this.sub_district),
      province:
        this.dataedit.showcard === true
          ? this.checkUndefined(this.province)
          : this.checkUndefined(this.province),
      district:
        this.dataedit.showcard === true
          ? this.checkUndefined(this.district)
          : this.checkUndefined(this.district),
      phones: phones,
    };

    let validate: string = this.validateRequest(addr_type, addr);
    if (validate != "") {
      return await this.ErrorMsg(validate);
    }

    let reqBody = this.getRequestBodyData(addr_type, addr);
    console.log("[confirmBuyer] reqBody : ", reqBody);

    let url = this.apiservice.apiUrl + this.apiservice.updateCustomer;
    try {
      this.apiservice._post(url, reqBody).then(async (res: any) => {
        console.log("[confirmBuyer] response : ", res);
        if (res.statusCode === 200) {
          _deleteStorage(STORAGE.DATA_EDIT);
          _setStorage(STORAGE.DATA_EDIT, res.data.address_detail);
          this.datasave = res.data;
          for (let i = 0; i < this.datasave.length; i++) {
            if (this.datasave[i].buyer_branch_no != "")
              this.buyer_main_branch_no = " ";
          }

          const alert = await this.alertController.create({
            cssClass: "my-custom-class",
            message: "บันทึกข้อมูลเรียบร้อย",
            buttons: [
              {
                text: "OK",
                cssClass: "alertButton",
                handler: (blah) => {
                  this.showbtn1 = false;
                  this.showbtn2 = false;
                  this.showbtn3 = false;
                  this.dataedit.showadd = true;
                  this.showTH = true;
                  this.showEN = true;
                  this.dataedit.showsaveEN = false;
                  this.dataedit.showsaveTH = false;
                  this.dataedit.showbranch2 = true;
                  this.showaddrTH = true;
                  this.showaddrEN = true;
                  this.dataedit.showtype1 = true;
                  this.showContinue = true;
                  this.showback = false;
                },
              },
            ],
          });
          await alert.present();
        } else {
          this.ErrorMsg(res.statusMessage);
        }
      });
    } catch (error) {
      // this.ErrorMsg(errMsg.error);
    }
  }

  Continue() {
    this.appService.setActive(3);
    _setStorage(STORAGE.DATA_ABB, this.datasave[0]);
    _setStorage(STORAGE.DATA_SELECTTAXINVOICE, this.datasave);
    _setStorage(STORAGE.DATA_EDIT, this.datasave[0]);
    this.route.navigate(["/tax-invoice-search-buy"]);
  }

  checkUndefined(data: string) {
    if (!data || data === undefined) return "";
    return data;
  }

  validateRequest(addr_type: string, addr: any): string {
    console.log("[validateRequest] START >>>>>");
    // Validate buyer information
    if (!this.buyer_type) return errMsg.buyer_type;
    if (!this.dataedit.buyer_company_name) return errMsg.buyer_company_name;
    if (!this.dataedit.buyer_tax_id) return errMsg.buyer_tax_id;

    let email = "";
    const address = this.dataedit.address_detail[0];

    if (addr_type === "1") {
      // Thai address validation
      if (this.isAddress) {
        if (!this.addressline1) return errMsg.errorAddressline1;
        if (!this.postcode) return errMsg.postcode;
      } else {
        const postcode = this.dataAddress.postcode;
        const province = this.province;
        const filterPostcode = this.groupAddress.filter(
          (f) => f.zipcode === Number(postcode)
        );
        const filterProvince = this.groupAddress.filter(
          (f) => f.province === province
        );
        if (!address.house_no) return errMsg.house_no;
        if (!address.postcode) return errMsg.postcode;
        if (postcode && filterPostcode.length === 0) return errMsg.notpostcode;
        if (!addr.sub_district) return errMsg.sub_district;
        if (!addr.district) return errMsg.district;
        if (!addr.province) return errMsg.province;
        if (addr.province && filterProvince.length === 0) return errMsg.notprovince;
        email = this.dataAddress.email;
      }
    } else {
      // International address validation
      if (!this.addrENProvince) return errMsg.addrENProvince;
      if (!this.addrENPostCode) return errMsg.addrENPostCode;
      if (!this.addrENCountry) return errMsg.addrENCountry;
      email = this.emailEN;
    }

    // Email validation
    if (email) {
      const re =
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!re.test(email)) return "รูปแบบ email ไม่ถูกต้อง";
    }
    console.log("[validateRequest] SUCCESS >>>>>");
    return "";
  }

  getRequestBodyData(addr_type: string, addr_detail: any) {
    let address = this.dataedit.address_detail[0];
    let result = {
      updateCustomerData: {
        buyer_id: this.dataedit.buyer_id,
        buyer_type: this.buyer_type,
        buyer_company_name: this.dataedit.buyer_company_name,
        buyer_people_id: "",
        buyer_main_branch_no: this.dataedit.buyer_main_branch_no,
        buyer_branch_no:
          this.dataedit.buyer_branch_no === ""
            ? ""
            : this.dataedit.buyer_branch_no.padStart(5, "0"),
        buyer_citizen_id: this.dataedit.buyer_citizen_id,
        buyer_tax_id: this.dataedit.buyer_tax_id,
        buyer_passpost_id: this.dataedit.buyer_passpost_id,
        buyer_agree_tmp: this.buyer_agree_tmp, // ===>>> key tmp [ ยินยอม Y / ไม่ยินยอม N]
        user_id: this.userID,
        template_lang: this.template_lang,
        buyer_status: "active",
        address_detail: {
          addr_id: this.dataAddress.addr_id.toString(),
          type_addr: addr_type,
          building_no: address.building_no || "",
          building_name: address.building_name,
          house_no: address.house_no,
          room_no: address.room_no,
          floor: address.floor,
          village_no: address.village_no,
          lane: address.lane,
          road: address.road,
          sub_district: addr_detail.sub_district,
          district: addr_detail.district,
          province: addr_detail.province,
          postcode: String(address.postcode),
          phone: addr_detail.phones.join(","),
          fax: "",
          email: addr_type == "1" ? this.dataAddress.email : this.emailEN,
          address_status: "active",
          addr_agree_tmp: this.buyer_agree_tmp,
          inter_province: this.addrENProvince,
          inter_postcode: this.addrENPostCode,
          inter_country: this.addrENCountry,
          inter_tel: this.telEN,
          inter_address_line1: this.addrEN,
          inter_fax: "",
          seller_id: this.dataAddress.seller_id,
          buyer_id: this.dataedit.buyer_id,
          user_id: this.userID,
          is_addresstxt: this.isAddress,
          addressline1: this.addressline1 || "",
        },
      },
    };

    return result;
  }
}
